import { render, staticRenderFns } from "./ImageResolutionSettings.vue?vue&type=template&id=167a6901"
import script from "./ImageResolutionSettings.vue?vue&type=script&lang=js"
export * from "./ImageResolutionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports